import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import StorePage from './pages/StorePage';
import CatalogPage from './pages/CatalogPage';
import InventoryPage from './pages/InventoryPage';
import CRMPage from './pages/CRMPage';
import AnalyticsPage from './pages/AnalyticsPage';
import POSPage from './pages/POSPage';
import PromotionsPage from './pages/PromotionsPage';
import SettingsPage from './pages/SettingsPage';
import SuppliersPage from './pages/SuppliersPage';
import AssortmentPage from './pages/AssortmentPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{color:'#fff',padding:'40px',textAlign:'center'}}>Завантаження...</div>;
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/store/:id" element={<PrivateRoute><StorePage /></PrivateRoute>} />
          <Route path="/catalog/:id" element={<PrivateRoute><CatalogPage /></PrivateRoute>} />
          <Route path="/inventory/:id" element={<PrivateRoute><InventoryPage /></PrivateRoute>} />
          <Route path="/crm" element={<PrivateRoute><CRMPage /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
          <Route path="/analytics/:id" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
          <Route path="/pos/:id" element={<PrivateRoute><POSPage /></PrivateRoute>} />
          <Route path="/promotions/:id" element={<PrivateRoute><PromotionsPage /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="/suppliers" element={<PrivateRoute><SuppliersPage /></PrivateRoute>} />
          <Route path="/assortment" element={<PrivateRoute><AssortmentPage /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
